// extracted by mini-css-extract-plugin
module.exports = {"searchInput":"_1WWY6-mUoBcIehE5siM-r0","searchIcon":"_15efIgk00WBwAscO4gFKtO"};